import { render, staticRenderFns } from "./Carousel_cards.vue?vue&type=template&id=461622c4&"
import script from "./Carousel_cards.vue?vue&type=script&lang=js&"
export * from "./Carousel_cards.vue?vue&type=script&lang=js&"
import style0 from "./Carousel_cards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports